import CollectionSite from "../Location/LocationModel/CollectionSite"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function CollectionSiteInfoGet(formFoxVendorAN?: number, collectionVendorID?: number) {
  let params = {}
  if (formFoxVendorAN) {
    params = {...params, formFoxVendorAN: formFoxVendorAN.toString()}
  }
  if (collectionVendorID) {
    params = {...params, collectionVendorID: collectionVendorID.toString()}
  }
  const requestBody: string = new URLSearchParams(params).toString()
  return ObservableFromFetch<CollectionSite>("WorkforceOrder/GetCollectionSiteInfo?" + requestBody)
}
